import React, { useState, useEffect } from 'react';
import * as Icon from "react-bootstrap-icons";
import { Col } from "react-bootstrap";
import { v4 } from "uuid";
import Form from 'react-bootstrap/Form';
import "./InputBox.css";
import Select from "react-select";
import { Spacer } from './Spacer';

const RadioOptionRenderer = (props) => {
    // console.log("PROPS: ", props)
    const [fieldSchema, setFieldSchema] = useState(props.field)
    /**
     * Update primary radio field schema
     */
    useEffect(() => {
        setFieldSchema(props.field)
    }, [props.field])

    const [selectedFields, setSelectedFields] = useState([])
    /**
     * Update primary radio field schema
     */
    useEffect(() => {
        if (props.rbprops.selectedfields !== undefined) {
            setSelectedFields(props.rbprops.selectedfields)
        }
    }, [props.rbprops.selectedfields])
    const [selectedField, setSelectedField] = useState()
    const [radioList, setRadioList] = useState()
    const [inputValue, setInputValue] = useState(fieldSchema.label)
    const [requiredToggle, setRequiredToggle] = useState(fieldSchema.mandatory);
    // Setting default WIDTH select options
    const [widthOptions, setWidthOptions] = useState([
        {
            value: "12",
            label: "100%",
            id: "12"
        },
        {
            value: "9",
            label: "75%",
            id: "9"
        },
        {
            value: "8",
            label: "66%",
            id: "8"
        },
        {
            value: "6",
            label: "50%",
            id: "6"
        },
        {
            value: "4",
            label: "33%",
            id: "4"
        },
        {
            value: "3",
            label: "25%",
            id: "3"
        }
    ])

    const [selectedWidth, setSelectedWidth] = useState(widthOptions.find((obj) => obj.id === `${fieldSchema.width}`))
    const [topMargin, setTopMargin] = useState((fieldSchema.margins !== undefined ? fieldSchema.margins["top"] : 5))
    const [rightMargin, setRightMargin] = useState((fieldSchema.margins !== undefined ? fieldSchema.margins["right"] : 0))
    const [bottomMargin, setBottomMargin] = useState((fieldSchema.margins !== undefined ? fieldSchema.margins["bottom"] : 5))
    const [leftMargin, setLeftMargin] = useState((fieldSchema.margins !== undefined ? fieldSchema.margins["left"] : 0))

    /**
     * Update the property of field component inside the current schema with provided value
     * @param {*} field: Field component 
     * @param {*} key: The property to be changed
     * @param {*} value: The entered value in input field
     */
    const UpdateMarginToPreview = (field, key, side, value) => {
        const updatedComponents = Object.assign(field)
        if (Object.keys(updatedComponents).includes("margins")) {
            updatedComponents[key][side] = value;
        } else {
            Object.assign(updatedComponents, { "margins": { "top": 5, "right": 0, "bottom": 5, "left": 0 } })
            Object.assign(updatedComponents[key], { [side]: value });
        }
        setFieldSchema(updatedComponents)
        props.rbprops.updatecomponent(
            field, "margins", field["margins"]
        )
    }

    /**
     * Update current radiolist when parent radiolist is updated
     */
    useEffect(() => {
        setRadioList(props.radiolist)
    }, [props.radiolist])

    /**
     * Updating margins for the field
     * @param {*} event: Number input trigger event
     */
    const updateTopMargin = (event) => {
        setTopMargin(event.target.value)
        UpdateMarginToPreview(fieldSchema, "margins", "top", parseInt(event.target.value))
    }

    /**
     * Updating margins for the field
     * @param {*} event: Number input trigger event
     */
    const updateRightMargin = (event) => {
        setRightMargin(event.target.value)
        UpdateMarginToPreview(fieldSchema, "margins", "right", parseInt(event.target.value))
    }

    /**
     * Updating margins for the field
     * @param {*} event: Number input trigger event
     */
    const updateBottomMargin = (event) => {
        setBottomMargin(event.target.value)
        UpdateMarginToPreview(fieldSchema, "margins", "bottom", parseInt(event.target.value))
    }

    /**
     * Updating margins for the field
     * @param {*} event: Number input trigger event
     */
    const updateLeftMargin = (event) => {
        setLeftMargin(event.target.value)
        UpdateMarginToPreview(fieldSchema, "margins", "left", parseInt(event.target.value))
    }

    /**
     * Updating the width for the given field
     * @param {*} event: Width select trigger event
     * @param {*} field: Field component
     */
    const updateFieldWidth = (event, field) => {
        const index = radioList.findIndex((obj) => obj.id === fieldSchema.id)
        const updatedField = radioList[index]
        updatedField["width"] = parseInt(event.value)
        radioList.splice(index, 1, updatedField)
        props.rbprops.updatecomponent(
            field, "width", parseInt(event.value)
        )
    }

    /**
     * Update the label property of field component inside the field schema with provided value
     * @param {*} event: Width select trigger event 
     * @param {*} field: Field component
     */
    const updateFieldLabel = (event, field) => {
        const index = radioList.findIndex((obj) => obj.id === fieldSchema.id)
        const updatedField = radioList[index]
        updatedField["label"] = event.value
        radioList.splice(index, 1, updatedField)
        props.rbprops.updatecomponent(
            field, "label", event.label
        )
    }

    /**
     * Remove the provided component from schema
     * @param {*} field: Field component
     */
    const removeOption = (field) => {
        const newList = [...radioList]
        const index = newList.findIndex((obj) => obj.id === field.id)
        if (index !== -1) {
            newList.splice(index, 1)
        }
        setRadioList(newList)
        props.setradiolist(newList)
        props.rbprops.removecomponent(field)
    }

    // The required toggle swith
    const Switch = ({ isToggled, onClick }) => {
        return (
            <label className="switch">
                <input type="checkbox" checked={isToggled} onChange={onClick} style={{ marginLeft: 10 }} />
                <span className="super-admin-slider super-admin-round"></span>
            </label>
        );
    };

    /**
     * Updating the field required for any INPUT
     * @param {*} field: field to be updated
     */
    const updateRequired = (field) => {
        setRequiredToggle(!requiredToggle)
        const index = radioList.findIndex((obj) => obj.id === fieldSchema.id)
        const updatedField = radioList[index]
        updatedField["mandatory"] = !requiredToggle
        radioList.splice(index, 1, updatedField)
        props.rbprops.updatecomponent(
            field, "mandatory", !requiredToggle
        )
    }

    return (
        <>
            <div className='flex-row-center-start' style={{ margin: "0px 0px 10px 0px", paddingTop: 10, borderTop: "1px solid lightgray" }}>
                <Col md={1} className='flex-row-center-center'>
                    <Icon.Circle style={{ fontSize: 20, marginTop: 10, color: "var(--theme1_primary)", cursor: "pointer" }} />
                </Col>
                <Col md={5} style={{ margin: "0px 10px" }}>
                    <label style={{ fontWeight: 500, fontSize: 8 }}>Label</label>
                    <Select
                        options={selectedFields}
                        value={selectedField}
                        onChange={(event) => {
                            setSelectedField(event)
                            updateFieldLabel(event, fieldSchema)
                        }}
                        placeholder={"Select field"}
                        aria-label="Default"
                        autosize={true}
                        className='custom-select '
                        classNamePrefix="react-select"
                    />
                </Col>
                <Col md={3}>
                    <label style={{ fontWeight: 500, fontSize: 8 }}>Width</label>
                    <Select
                        options={widthOptions}
                        value={selectedWidth}
                        onChange={(event) => {
                            setSelectedWidth(event)
                            updateFieldWidth(event, fieldSchema)
                        }}
                        placeholder={"100%"}
                        aria-label="Default"
                        autosize={true}
                        className='custom-select '
                        classNamePrefix="react-select"
                    />
                </Col>
                <Col md={2} className='flex-row-center-center'>
                    <div style={{ width: "fit-content", margin: "-10px 0px 10px 0px" }} >
                        <label style={{ fontWeight: 500, fontSize: 8, margin: "10px 0px 10px 5px" }}>Required</label>
                        <Switch
                            isToggled={requiredToggle}
                            onClick={() => updateRequired(fieldSchema)}
                        />
                    </div>
                </Col>
                <Col md={1} className='flex-row-center-center'>{
                    props.templatestatus !== "Final" ?
                        <Icon.DashCircleFill style={{ fontSize: 20, marginTop: 10, color: "var(--theme1_primary)", cursor: "pointer" }} onClick={() => removeOption(fieldSchema)} />
                        : <></>
                }
                </Col>
            </div>
            <div className='flex-row-center-center' style={{ padding: "0px 0px 10px 0px", margin: "0px 0px 10px 0px" }}>
                <Spacer
                    topMargin={topMargin}
                    rightMargin={rightMargin}
                    bottomMargin={bottomMargin}
                    leftMargin={leftMargin}
                    updateTopMargin={(event) => updateTopMargin(event)}
                    updateRightMargin={(event) => updateRightMargin(event)}
                    updateBottomMargin={(event) => updateBottomMargin(event)}
                    updateLeftMargin={(event) => updateLeftMargin(event)}
                />
            </div>
        </>
    )
}

export const RequiredRadios = (rbprops) => {
    console.log("RB PROPS: ", rbprops)
    const [baseId, setBaseId] = useState(rbprops.baseid)
    const [fieldSchema, setFieldSchema] = useState(rbprops.fieldschema)
    const [radioList, setRadioList] = useState([...fieldSchema])
    const [radioGroupId, setRadiogroupId] = useState(rbprops.radiogroup)
    const [templateStatus, setTemplateStatus] = useState(rbprops.templatestatus)
    useEffect(() => {
      console.log("RADIO GROUP ID: ", radioGroupId)
    }, [radioGroupId])
    
    useEffect(() => {
        console.log("fieldSchema for radio button: ", fieldSchema)
    }, [rbprops.fieldschema])

    /**
     * Every time the parent base id is updated update it in child
     */
    useEffect(() => {
        setBaseId(rbprops.baseid)
    }, [rbprops.baseid])

    /**
     * Create a new radio field and add it to the parent initial data
     */
    const addOption = () => {
        const newId = v4()
        setRadioList([...radioList, {
            "id": newId,
            "label": null,
            "value": "",
            "approval": false,
            "mandatory": false,
            "hidden": false,
            "radiogroup": radioGroupId
        }])
        rbprops.addnewcomponent({
            "id": newId,
            "label": "",
            "approval": false,
            "mandatory": false,
            "hidden": false,
            "disabled": false,
            "type": "radio",
            "example": null,
            "radiogroup": radioGroupId,
            "pivot": true,
            "pivotreverse": false,
            "value": "",
            "width": 12,
            "margins": { "top": 5, "right": 0, "bottom": 5, "left": 0 }
        })
    }

    return (
        <Form className='no-padding'>
            <div className='flex-row-center-start' style={{ padding: "10px 0px" }}>
                <p style={{ marginRight: 20, marginBottom: 0 }}>Radio options </p>
                {
                    templateStatus !== "Final" ?
                        <Icon.PlusCircleFill style={{ fontSize: 20, color: "var(--theme1_primary)", cursor: "pointer" }} onClick={() => addOption()} />
                        :
                        <></>
                }
            </div>
            {
                radioList.map((field, i) =>
                (<RadioOptionRenderer
                    key={field.id}
                    index={i}
                    field={field}
                    rbprops={rbprops}
                    radiolist={radioList}
                    setradiolist={(radiolist) => setRadioList(radiolist)}
                    templatestatus={templateStatus}
                />)
                )
            }
        </Form>
    )
}